import { computed, ref } from 'vue'
import FormName from './forms/FormName'
import FormAddress from './forms/FormAddress'
import FormContact from './forms/FormContact'
import FormOccupation from './forms/FormOccupation'
import FormOccupationOther from './forms/FormOccupationOther'
import FormIncludeFamily from './forms/FormIncludeFamily'
import FormDataPrivacy from './forms/FormDataPrivacy'
import FormOccupationEmployed from './forms/FormOccupationEmployed'
import FormSummary from './forms/FormSummary'

export default {
  props: ['step', 'friend', 'step-width', 'data'],
  emits: ['go-to-next', 'go-to-previous'],
  components: {
    FormName,
    FormAddress,
    FormContact,
    FormOccupation,
    FormOccupationOther,
    FormIncludeFamily,
    FormDataPrivacy,
    FormOccupationEmployed,
    FormSummary
  },
  setup (props, ctx) {
    const stepRef = ref(null)
    const formular = ref(null)

    const onPreviousButtonClicked = () => {
      ctx.emit('go-to-previous', props.step.id)
    }

    const onNextButtonClicked = async () => {
      if (props.step.formComponent) {
        if (props.step.summary) {
          ctx.emit('go-to-next', props.step.id)
        } else if(await formular.value.v$.$validate()) {
          ctx.emit('go-to-next', props.step.id)
        }
      }

      if (props.step.isLast) {
        window.location.href = window.location.origin
      }
    }

    return {
      stepRef,
      formular,
      onPreviousButtonClicked,
      onNextButtonClicked,
      hasControls: computed(() => props.step && props.step.controls && (props.step.controls.previous !== null || props.step.controls.next !== null)),
      style: computed(() => {
        return {
          width: props.stepWidth + 'px'
        }
      })
    }
  },
  template: `
    <div :id="step.id" class="step" :class="{'step--hidden': !step.visible}" ref="stepRef" :style="style">
        <div class="application">
            <div class="application__outer">
                <div class="application__description">
                    <h2 class="application__headline">{{step.title}}</h2>
                    <p v-if="step.description" v-html="step.description"></p>
                </div>
                <div class="application__form">
                    <div class="application__form__inner">
                        <form class="application__fields form">
                        
                            <div v-if="step.isLast">
                                <p class="display-h3">Wie geht es nun weiter?</p>
                                
                                <div class="quickome__status-bar">
                                    <div class="quickome__status-bar-item quickome__status-bar-item--done">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256,0C114.84,0,0,114.84,0,256S114.84,512,256,512,512,397.16,512,256,397.16,0,256,0ZM389.23,170.2,223.82,367.13a19.71,19.71,0,0,1-14.77,7h-.34a19.67,19.67,0,0,1-14.63-6.52l-70.89-78.77a19.69,19.69,0,1,1,28.65-27c.21.23.42.45.62.68l55.74,61.94L359.08,144.87a19.69,19.69,0,0,1,30.15,25.33Z"></path></svg>
                                        Anmeldung absenden
                                    </div>
                                    <div class="quickome__status-bar-item quickome__status-bar-item--current">
                                        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><defs></defs><path d="M419,256A163,163,0,1,0,256,419,163,163,0,0,0,419,256Z"></path><path d="M494,256C494,124.6,387.4,18,256,18S18,124.6,18,256,124.6,494,256,494,494,387.4,494,256Z" style="fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 32px;"></path></svg>
                                        Anmeldung wird bearbeitet
                                    </div>
                                    <div class="quickome__status-bar-item">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M419,256A163,163,0,1,0,256,419,163,163,0,0,0,419,256Z"></path></svg>
                                        Rückmeldung erhalten
                                    </div>
                                </div>
                            </div>
                        
                            <component 
                                ref="formular"
                                v-if="step.formComponent"
                                :is="step.formComponent"
                                :form-data="step.formData"
                                :form-labels="step.formLabels"
                                :form-options="step.formOptions"
                                :data="data"
                            />
                
                            <template v-if="hasControls || step.isLast">
                            <!-- Application Controls -->
                                <div class="application__controls">
                                    <button v-if="step.controls.previous"
                                        type="button"
                                        class="btn btn--violet-border"
                                        name="backButton"
                                        @click="onPreviousButtonClicked">
                                        {{step.controls.previous}}
                                    </button>
                                    
                                    <button v-if="step.controls.next"
                                    type="button"
                                    class="btn btn--secondary"
                                    style="margin-left: auto"
                                    name="nextButton"
                                    @click="onNextButtonClicked">
                                        {{step.controls.next}}
                                    </button>
                                </div>
                            </template>
                
                            <div class="application__ssl-notice"><span class="application__ssl-notice__icon"></span><span class="application__ssl-notice__text">Sichere Übertragung Ihrer Daten mit SSL-Verschlüsselung</span></div>
                            <div v-if="friend" class="application__friend" style="background: yellow; color: black; padding: 10px; position: absolute; top: 0; right: 0;">Weiterempfehlung</div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `
}
